import { Component, OnInit } from '@angular/core';
import { AVIAConnectService } from './../../avia-connect.service';

@Component({
  selector: 'app-load-testing-page2',
  templateUrl: './load-testing-page2.component.html',
  styleUrls: ['./load-testing-page2.component.scss']
})
export class LoadTestingPage2Component implements OnInit {
  gotit = false;
  result:any;
  constructor( private aviaService: AVIAConnectService ) { }

  async ngOnInit() {
    this.result = await this.aviaService.xhr( 'GET', '/12378945ASDFJHK-45789-ZCV-AVIA-134579-LTP1', { 'Accept': 'application/json' } );
    this.result = this.result.body;
    this.gotit=true;
  }

}
